
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

import WaterBills from '@/pages/water/Bills';
import WaterConsumers from '@/pages/water/Consumers';
import WaterReports from '@/pages/water/Reports';
import WaterKpiDashboard from '@/pages/water/KpiDashboard';
import WaterAnalytics from '@/pages/water/Analytics';
import WaterDeviceHealth from '@/pages/water/DeviceHealth';

const waterRoutes = (
  <>
    <Route path="/water/bills" element={
      <ProtectedRoute>
        <WaterBills />
      </ProtectedRoute>
    } />
    <Route path="/water/consumers" element={
      <ProtectedRoute>
        <WaterConsumers />
      </ProtectedRoute>
    } />
    <Route path="/water/reports" element={
      <ProtectedRoute>
        <WaterReports />
      </ProtectedRoute>
    } />
    <Route path="/water/dashboard" element={
      <ProtectedRoute>
        <WaterKpiDashboard />
      </ProtectedRoute>
    } />
    <Route path="/water/kpi-dashboard" element={
      <ProtectedRoute>
        <WaterKpiDashboard />
      </ProtectedRoute>
    } />
    <Route path="/water/analytics" element={
      <ProtectedRoute>
        <WaterAnalytics />
      </ProtectedRoute>
    } />
    <Route path="/water/device-health" element={
      <ProtectedRoute>
        <WaterDeviceHealth />
      </ProtectedRoute>
    } />
  </>
);

export default waterRoutes;
